import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './AdminCollapsibleContainer.module.css';

const DraggableButton = ({ containerOpen }) => (
  <span
    data-tip="To reorder this variable, please first collapse its accordion."
    data-tip-disable={!containerOpen}
    data-for="draggable-button"
  >
    <button
      className={classNames('naked-button', [styles.draggableButton], {
        'draggable-button': !containerOpen,
      })}
      type="button"
      disabled={containerOpen}
    >
      <i className="far fa-ellipsis-v" />
      <i className="far fa-ellipsis-v" />
    </button>
  </span>
);

DraggableButton.propTypes = {
  containerOpen: PropTypes.bool.isRequired,
};

export default DraggableButton;
